import DashboardCard from "../../components/dashboard/Card";
import React, { useState, useEffect, useRef } from "react";
import { Table, Row, DatePicker, Select } from "antd";
import Chart from "react-apexcharts";
import NewRequest from "../../assets/images/icon/NewRequest.png";
import Closed from "../../assets/images/icon/Closed.png";
import Executed from "../../assets/images/icon/Executed.png";
import Execution from "../../assets/images/icon/Execution.png";
import UnderNegotiation from "../../assets/images/icon/UnderNegotiation.png";
import dayjs from "dayjs";
import ChartComponent from "../../components/chart/ChartComponent";
import RecentContractsAudit from './recentContracts'
import ExpiringContracts from "./expiringContracts";
import axiosInstance from "../../utils/axiosInstance";


const { RangePicker } = DatePicker;
const { Option } = Select;

function CompanyDashboard() {
  const [contractsCount, setContractsCount] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [customDateRange, setCustomDateRange] = useState(null);
  const [statusData, setStatusData] = useState([]);


  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    setCustomDateRange(null);
    fetchContractsCount();
  };

const handleCustomDateChange = async (dates) => {
  if (!dates || dates.length !== 2) return;

  setCustomDateRange(dates);

  const startDate = dates[0].format("YYYY-MM-DD"); // ✅ Dayjs format
  const endDate = dates[1].format("YYYY-MM-DD");

  try {
    const response = await axiosInstance.post(`/dashboard/executed_agreement_count/`, {
      start_date: startDate,
      end_date: endDate,
    });

    setContractsCount(response.data.data);
  } catch (error) {
    console.error("Error fetching filtered contract count", error);
  }
};


  const showPagination = false;

  const fetchContractsCount = async () => {
    try {
      const response = await axiosInstance.post(`/dashboard/executed_agreement_count/`);
      setContractsCount(response.data.data);
    } catch (error) { }
  };
  useEffect(() => {
    fetchContractsCount();
  }, []);


  // const monthAbbreviations = contractsCount?.map(entry => entry?.month_name.slice(0, 3)) || [];
  const monthAbbreviations =
    Array.isArray(contractsCount) && contractsCount.length > 0
      ? contractsCount.slice(0, selectedFilter || 3).map((entry) => {
        const monthAbbrev = entry?.month_name?.slice(0, 3) || "";
        const yearLastTwoDigits = entry?.year?.toString().slice(-2) || "";
        return `${monthAbbrev} ${yearLastTwoDigits}`;
      })
      : [];

  // const dataCount = contractsCount?.map((entry) => entry?.count) || [];
  const dataCount =
    Array.isArray(contractsCount) && contractsCount.length > 0
      ? contractsCount
        .slice(0, selectedFilter || 3)
        .map((entry) => entry?.count || 0)
      : [];

  const maxDataValue = Math.max(...dataCount);
  const yaxisOptions = {
    max: maxDataValue < 10 ? 10 : maxDataValue,
  };

  const state = {
    series: [
      {
        name: "Executed Contracts",
        data: dataCount,
      },
    ],
    options: {
      chart: {
        type: "bar",
        zoom: {
          enabled: false,
        },
        dropShadow: {
          enabled: false,
        },
        toolbar: {
          show: true,
          tools: {
            download: true,
          },
          export: {
            csv: {
              filename: "Executed-Contracts-Summary",
            },
            svg: {
              filename: "Executed-Contracts-Chart",
            },
            png: {
              filename: "Executed-Contracts-Chart",
            },
          },
        },
      },
      xaxis: {
        show: true,
        categories: monthAbbreviations,
      },
      yaxis: yaxisOptions,
      title: {
        text: "No. of Executed Contracts",
        style: {
          fontSize: "20px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      plotOptions: {
        bar: {
          distributed: false,
          endingShape: "flat", // changed from "false"
        },
      },
      colors: ["#fde68a"],
    },
  };


  const allAgreementCounts = async () => {
    try {
      const response = await axiosInstance.get(`/dashboard/agreement_count/`);
      setStatusData(response.data.data);
    } catch (error) { }
  };
  useEffect(() => {
    allAgreementCounts();
  }, []);

  const disabledDate = (current) => {
    const today = dayjs().endOf("day"); // allow today
    return current && current > today;
  };

  return (
    <div className="dashboard-wrapper ">
      <div className="dashboard h-[100%] ">
        <div className="mb-4">
          <Row justify="space-around -ml-6 mr-4">
            <DashboardCard
              bgColor="bg-sky-200"
              icon={NewRequest}
              to="/admin/contracts/agreement_type/fresh_request/"
              text="Fresh Request"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.FRESH_REQUEST
              }
              total={
                statusData && statusData.count && statusData.count.FRESH_REQUEST
              }
            />

            <DashboardCard
              bgColor="bg-orange-100"
              icon={UnderNegotiation}
              to="/admin/contracts/agreement_type/under_negotiation/"
              text="Under Negotiation"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.UNDER_NEGOTIATION
              }
              total={
                statusData &&
                statusData.count &&
                statusData.count.UNDER_NEGOTIATION
              }
            />

            <DashboardCard
              bgColor="bg-teal-100"
              icon={Execution}
              to="/admin/contracts/agreement_type/under_execution/"
              text="Under Execution"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.UNDER_EXECUTION
              }
              total={
                statusData &&
                statusData.count &&
                statusData.count.UNDER_EXECUTION
              }
            />

            <DashboardCard
              bgColor="bg-lime-100"
              icon={Executed}
              to="/admin/contracts/agreement_type/executed/"
              text="Executed"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.EXECUTED
              }
              total={
                statusData && statusData.count && statusData.count.EXECUTED
              }
            />

            <DashboardCard
              bgColor="bg-red-200"
              icon={Closed}
              to="/admin/contracts/agreement_type/transaction_closed/"
              text="Transaction Cancelled"
              today={
                statusData &&
                statusData.today_count &&
                statusData.today_count.TRANSACTION_CLOSED
              }
              total={
                statusData &&
                statusData.count &&
                statusData.count.TRANSACTION_CLOSED
              }
            />
          </Row>
        </div>

        <div className="container mx-auto flex  flex-col md:flex-row ">
          <div className="w-full md:w-1/2 pr-4 ">
            <div className="bg-white flex flex-col rounded-t-lg ">
              <div className="ml-4 flex flex-row justify-between items-left pr-4 mb-2 mt-2 ">
                <RangePicker
                  onChange={handleCustomDateChange}
                  value={customDateRange}
                  disabledDate={disabledDate}
                  className="pr-4"
                />
                <Select
                  defaultValue="3"
                  onChange={handleFilterChange}

                  style={{ width: "100px" }}
                  className="mx-4"
                >
                  <Option value="3">3 Months</Option>
                  <Option value="6">6 Months</Option>
                  <Option value="12">1 Year</Option>
                </Select>
              </div>
            </div>
            <div className={`${state.rounded} p-4 bg-slate-50 rounded-b-lg`}>
              <Chart
                options={state.options}
                series={state.series}
                type="bar"
                height={300}
                {...state.additionalProps}
              />
            </div>
            {/* Other charts go here */}
          </div>
          <ExpiringContracts />
        </div>
        <RecentContractsAudit />
      </div>
    </div>
  );
}

export default CompanyDashboard;
